import { value } from '@takeshape/util';
import isString from 'lodash/isString.js';
import { hasEveryKey } from "../util/has.js";
const serviceProvider = {
    name: 'netlify',
    title: 'Netlify',
    description: 'Netlify is a deployment option.',
    categories: ['hosting'],
    links: [
        { title: 'Homepage', url: 'https://www.netlify.com/' },
        { title: 'Docs', url: '/docs/services/providers/netlify' }
    ],
    serviceType: 'deployment',
    createId: value('netlify'),
    checkQueryParams: value({}),
    getServerAuthentication: (options) => ({
        type: 'oauth2',
        authorizationUrl: 'https://app.netlify.com/authorize',
        clientId: 'netlifyClientId',
        responseType: 'token',
        redirectUrl: isString(options.baseUrl) ? `${options.baseUrl}/redirect_passthrough.html` : ''
    }),
    getConfig: value({
        title: 'Netlify',
        provider: 'netlify',
        serviceType: 'deployment',
        authenticationType: 'oauth2Bearer'
    }),
    getFormSchema: value({ type: 'object', properties: {} }),
    getFormConfig: value({
        order: []
    }),
    isCompleteConfig: hasEveryKey(['authentication'])
};
export default serviceProvider;
